import "../styles/BottomTabNavigation.css";
import { ReactComponent as TranscriptActiveIcon } from "../assets/transcript-active.svg";
import { ReactComponent as KeywordActiveIcon } from "../assets/keyword-active.svg";
import { ReactComponent as ChatActiveIcon } from "../assets/chat-active.svg";
import { ReactComponent as TranscriptIcon } from "../assets/transcript.svg";
import { ReactComponent as KeywordIcon } from "../assets/keyword.svg";
import { ReactComponent as ChatIcon } from "../assets/chat.svg";

interface TabItem {
  key: string;
  label: string;
  icon: React.ReactNode;
  activeIcon: React.ReactNode;
}

const tabs: TabItem[] = [
  {
    key: "transcript",
    label: "Transcript",
    icon: <TranscriptIcon />,
    activeIcon: <TranscriptActiveIcon />,
  },
  {
    key: "keywords",
    label: "Keywords",
    icon: <KeywordIcon />,
    activeIcon: <KeywordActiveIcon />,
  },
  {
    key: "summary",
    label: "Ask AI",
    icon: <ChatIcon />,
    activeIcon: <ChatActiveIcon />,
  },
];

const BottomTabNavigation = ({
  activeTab,
  setActiveTab,
}: {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}) => {
  return (
    <nav className="bottom-tab-navigation">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          className={`tab-item ${activeTab === tab.key ? "active" : ""}`}
          onClick={() => setActiveTab(tab.key)}
        >
          <span className="tab-icon">
            {activeTab === tab.key ? tab.activeIcon : tab.icon}
          </span>
          <span className="tab-label">{tab.label}</span>
        </button>
      ))}
    </nav>
  );
};

export default BottomTabNavigation;
